import { SET_FILES } from "../../constants/actionTypes";

const file = (state = {}, action) => {
  switch (action.type) {
    case SET_FILES:
      const { files } = state || {};
      return {
        files: action.files.length
          ? Array.from(
              new Set([
                ...(files || []),
                ...(action.files || []) //.map(({ ...x }) => ({ ...x }))
              ])
            )
          : []
      };
    default:
      return state;
  }
};

export default file;
